import styled from "styled-components";
import { Link } from "react-router-dom";

import colors from "core/colors";
import { handleTextSizeAndFont } from "core/BodyText/helpers";
import { BorderBottomLinkStyle } from "core/Typography";
import { bold as boldTextStyle } from "core/fontStyles";
import { easingSeconds } from "core/animation";

const LinkInNewRouter = styled(Link)`
    ${BorderBottomLinkStyle}
    border-bottom-color: ${colors.accent.lightMode.persian};
    color: ${colors.accent.lightMode.persian};
    font-size: ${handleTextSizeAndFont({ size: "md" })};
    transition: all ${easingSeconds};

    &:hover {
        border-bottom-color: ${colors.secondary.cosmic};
        color: ${colors.secondary.cosmic};
        transition: all ${easingSeconds};
    }

    &:active {
        border-bottom-color: ${colors.secondary.orca};
        color: ${colors.secondary.orca};
        ${boldTextStyle}
        transition: all ${easingSeconds};
    }
`;

export default LinkInNewRouter;
